<!-- Generated template for the ResultSearchListItemComponent component -->

<ion-card no-margin margin-bottom>
  <ion-item *ngIf="displayHead">
    <ion-avatar slot="start" (click)="showSportProfile()">
      <img src="/assets/imgs/default-image-32@1x.png" />
    </ion-avatar>
    <span inline-block (click)="showSportProfile()">
      <h2 class="ion-text-ellipsis ion-text-bold">{{ result.athleteName }}</h2>
      <p>{{ result.eventDate.toString() | transDate }}</p>
    </span>
  </ion-item>

  <ion-item [class.result-details]="displayHead" (click)="showResult()">
    <mysport-icon large [cid]="result.cid" item-start></mysport-icon>
    <h3 text-ellipsis [innerHtml]="result.resultText"></h3>
    <p text-ellipsis>
      <ion-icon ios="ios-calendar-outline" md="md-calendar"></ion-icon> {{ result.eventName }}
    </p>
  </ion-item>

  <ion-row class="result-actions">
    <ion-col col-4>
      <button ion-button icon-start clear small color="{{ color }}" (click)="(commentButton)?onCongrat():congrat()">
        <ion-icon name="md-thumbs-up" class="icon-up"></ion-icon>
        <div>{{ 'GLOBAL_CONGRATS' | translate }}</div>
      </button>
    </ion-col>
    <ion-col *ngIf="commentButton" col-4>
      <!-- TODO change API call congrat() to the right one -->
      <button ion-button icon-start clear small color="{{ color }}" (click)="onCongrat()" class="no-padding-left">
        <ion-icon name="md-text"></ion-icon>
        <div>Kommentieren</div>
      </button>
    </ion-col>
    <ion-col col-4>
      <button ion-button icon-start clear small color="{{ color }}" (click)="showRanglist(result)">
        <ion-icon name="list"></ion-icon>
        <div>{{ 'GLOBAL_RANKLIST' | translate }}</div>
      </button>
    </ion-col>
  </ion-row>
</ion-card>